import React, { useCallback } from 'react';
import { NoClickOutsideCheckbox } from '@pwc/appkit-react/lib/Checkbox';


const BookToTaxDifferencesCountryTaxTypeRenderer = params => {
  const { setValue, getValue, editable } = params;
  const onClickHandler = useCallback(() => {
    setValue(!getValue());
  },
  [getValue, setValue]);

  return <NoClickOutsideCheckbox onClick={onClickHandler} checked={getValue()} disabled={!editable(params)}/>;
};

export default BookToTaxDifferencesCountryTaxTypeRenderer;
